import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import { managePaymentCommandZodObject } from "../manage-payments/manage-payment.command";
import { payRequestIdZodSchema } from "./pay-request-id";

const payRequestCancelCommandZodObject = z
    .object({
        _id: idZodSchema,
        _createdAt: isoAndUnixZodSchema,
        _type: z.literal("PAY_REQUEST_CANCEL_COMMAND"),
        payRequestId: payRequestIdZodSchema,
        managePaymentCommand: managePaymentCommandZodObject,
    })
    .refine(item => {
        // At least and at most one cancellation
        return item.managePaymentCommand.cancellations.length === 1;
    }, "Pay request cancel command can need to contain at least one cancellation")
    .refine(item => {
        // Cancellations need to be a pay request cancellation
        return (
            item.managePaymentCommand.cancellations[0].type === "PAY_REQUEST"
        );
    }, "Pay request cancellation only handles pay request cancellation");

type PayRequestCancelCommand = z.infer<typeof payRequestCancelCommandZodObject>;
const payRequestCancelCommandZodSchema: z.ZodSchema<PayRequestCancelCommand> =
    payRequestCancelCommandZodObject;

type FactoryParams = Except<
    PayRequestCancelCommand,
    "_id" | "_type" | "_createdAt"
>;
const payRequestCancelCommandFactory = (params: FactoryParams) => {
    const command: PayRequestCancelCommand = {
        ...params,
        _id: generateId({ prefix: "cancel_pay_request_command__" }),
        _type: "PAY_REQUEST_CANCEL_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return command;
};

export {
    payRequestCancelCommandFactory,
    payRequestCancelCommandZodObject,
    payRequestCancelCommandZodSchema,
};
export type {
    FactoryParams as CancelPayRequestCommandFactoryParams,
    PayRequestCancelCommand,
};
